// extracted by mini-css-extract-plugin
export default {"input":"create-team-modal_input__qn3qJ"};